import { useEffect, useRef, useState } from "react";

export const useMaxWidthApplied = () => {
  const contentRef = useRef(null);
  const [maxWidth, setMaxWidth] = useState(0);

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        const currentWidth = entry.contentRect.width;

        if (currentWidth > maxWidth) {
          setMaxWidth(currentWidth);
        }
      }
    });

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      if (contentRef.current) {
        observer.unobserve(contentRef.current);
      }
    };
  }, [maxWidth]);

  return {
    contentRef,
    maxWidth,
  };
};
